import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ErrorMessage from 'components/ErrorMessage';
import Checkbox from './Checkbox';

const CheckboxWithLabel = ({
  testId,
  label,
  name,
  register,
  required,
  defaultChecked,
  className,
  leftSideClassName,
  checkboxClassName,
  error,
  isDisabled,
  ...rest
}) => {
  return (
    <label
      htmlFor={name}
      className="flex flex-1 flex-col lg:items-center mb-4 lg:flex-row"
    >
      <span className={leftSideClassName}></span>
      <div className={`input-form-wrapper ${className}`}>
        <div className="relative">
          <span className={`flex items-center`}>
            <Checkbox
              {...rest}
              name={name}
              register={register}
              required={required}
              defaultChecked={defaultChecked}
              isDisabled={isDisabled}
              className={checkboxClassName}
            />
            <span className="label text-xs">{label}</span>
          </span>
        </div>
        {!!error && <ErrorMessage message={error} />}
      </div>
    </label>
  );
};

CheckboxWithLabel.propTypes = {
  testId: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  required: PropTypes.bool,
  register: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.string,
  isDisabled: PropTypes.bool,
  checkboxClassName: PropTypes.string,
  leftSideClassName: PropTypes.string,
};
CheckboxWithLabel.defaultProps = {
  testId: 'checkbox',
  label: '',
  name: 'checkbox',
  defaultChecked: false,
  register: () => null,
  className: '',
  error: null,
  isDisabled: false,
  leftSideClassName: 'pb-1 lg:pb-0 lg:w-4/12',
};

export default memo(CheckboxWithLabel);
